import React, { useRef, useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel'
import { profitRank } from './api';
import { activityShare, isStorm, handleUploadTrace } from './stock';

import BackBtn from './imgs/back-btn@2x.png';
import AgainBtn from './imgs/again-btn@2x.png';
import UploadBtn from './imgs/upload-btn@2x.png';
import UploadSuccess from './imgs/upload-success@2x.png';
import ModalTips from './components/modal-tips';
import UploadSuccessConfirm from './imgs/upload-success-confirm@2x.png'
import UploadSuccessTitle from './imgs/upload-success-title@2x.png';

import UploadModal from "./components/upload-modal";
import ShareModal from './components/share';

const Ranks = ({ next, back, uniqueCode }) => {
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const shareRef = useRef();

  const [rankData, setRankData] = useState({});
  const modalRef = useRef();
  const uploadRef = useRef();

  useEffect(() => {
    profitRank({ uniqueCode, year: 2023 }).then(res => {
      setRankData(res);
    });

    handleUploadTrace('the-charts', 'visitor');
  }, []);

  const rankList = rankData.userIncomeList || [];

  const handleBack = () => {
    back();
  }

  const handleUploadProfit = () => {
    if (uploadSuccess) {
      modalRef.current.show({
        content: '恭喜您～本局收益已成功上传，请前往APP查看自己的排名吧。',
        confirmBtn: UploadSuccessConfirm,
        title: <img alt="" src={UploadSuccessTitle} style={{ width: 146, height: 23 }} />
      });
      return;
    }
    if (!isStorm) {
      uploadRef.current.show();

      handleUploadTrace('end-upload', 'click');
      return
    }
  }

  const handlePlayAgain = () => {
    shareRef.current.show();
  }

  const handleSuccess = () => {
    profitRank({ uniqueCode, year: 2023 }).then(res => {
      setRankData(res);
    });
    setUploadSuccess(true);

    /** */
    handleUploadTrace('upload-successful', 'click');
  }

  const formatProfit = (value) => {
    if (!Number(value)) {
      return '--'
    }
    const result = Number(value * 100).toFixed(2) + '%';
    return result;
  }

  const handleShareClick = useCallback(() => {
    next()
  }, []);

  const handleLinkToUser = (item) => {
    /** **/
    handleUploadTrace('download-app', 'click');

    const url = 'storm://app/userzone?userID=' + item.userId;
    window.location.href = url;
  }

  const transformText = (text) => {
    if (!text) {
      return '';
    }
    if (text.length > 7) {
      return text.slice(0, 7) + '...';
    }
    return text;
  }

  return (
    <Container>
      {
        isStorm &&
        <Header
          title="重生之股神模拟器"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
        />
      }
      
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <div className="rank-title">重生之收益大比拼</div>
          <div className="desc-box">
            <div className="desc-text1">榜单停止更新后</div>
            <div className="desc-text2">榜单第1名奖励<span className="award-num">888</span>元</div>
            <div className="desc-text2">第2名和第3名奖励<span className="award-num">288</span>元，第4名至第10名奖励<span className="award-num">88</span>元</div>
          </div>
          <div className="rank-head">
            <div className="head-date">榜单将于2024年1月25日0点停止更新    更新频率5秒/次</div>
            <div className="rank-head-title">
              <div className="head-seq1">排名</div>
              <div className="head-seq2">昵称</div>
              <div className="head-seq3">最高收益率</div>
            </div>
          </div>
          <div className="rank-wrap">
            <div>
              {rankList.map(((item, index) => {
                return <div key={item.userId} className={(index + 1) % 2 === 0 ? "rank-item rank-item-light" : "rank-item"}>
                  <div className="rank-seq">{index + 1}</div>
                  <div onClick={() => handleLinkToUser(item)} className="rank-user">
                    <img src={item.avatar} alt="" className="user-avatar"/>
                    <span className="rank-user-name">{transformText(item.nickname)}</span>
                  </div>
                  <div className="rank-profit">{isStorm ? formatProfit(item.incomeRatio) : '收益请前往APP查看'}</div>
                </div>
              }))}
            </div>
          </div>

          <div className="my-profit">
            <div className="bottom-raw bottom-raw-border">
              <span className="profit-title">我的最高收益</span>
              <span className="profit-value">{formatProfit(rankData.maxIncomeRatio)}</span>
            </div>
            <div className="bottom-raw bottom-raw-border">
              <span className="profit-title">我的本局收益</span>
              <span className="profit-value">{formatProfit(rankData.currentIncomeRatio)}</span>
            </div>
            <div className="bottom-raw">
              <img onClick={handleBack} alt="" src={BackBtn} className="options-btn1"/>
              {isStorm ? 
                <img
                  onClick={handlePlayAgain}
                  alt=""
                  src={AgainBtn}
                  className="options-btn2"
                /> :
                <img
                  onClick={handleUploadProfit}
                  alt=""
                  src={uploadSuccess ? UploadSuccess : UploadBtn}
                  className="options-btn2"
                />
              }
            </div>
          </div>
        </div>
      </div>
      <ModalTips ref={modalRef}/>
      <UploadModal ref={uploadRef} success={handleSuccess} />
      <ShareModal ref={shareRef} onShareClick={handleShareClick}/>
    </Container>
  );
}

export default React.memo(Ranks);

const Container = styled.div`
  .page-content {
    background-color: #B13B2C;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .rank-title {
      padding-top: 26px;
      font-size: 43px;
      font-weight: 800;
      color: #F4D4BC;
      line-height: 43px;
      padding: 26px 16px 0;
    }
  }
  .my-profit {
    position: absolute;
    padding: 21px 19px 21px 23px;
    background-color: #B13B2C;
    border-radius: 10px 10px 0px 0px;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    .bottom-raw {
      display: flex;
      justify-content: space-between;
    }
    .profit-title {
      font-size: 16px;
      font-weight: bold;
      color: #FFB847;
      line-height: 16px;
    }
    .profit-value {
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 16px;
    }
    .bottom-raw-border {
      margin-bottom: 16px;
    }
    .options-btn1 {
      width: 132px;
      height: 53px;
    }
    .options-btn2 {
      width: 141px;
      height: 53px;
    }
  }
  .desc-box {
    margin-top: 19px;
    padding: 0 16px 12px 17px;
    color: #F4D4BC;
    line-height: 16px;
    font-size: 16px;
    .desc-text1 {
      font-weight: normal;
      margin-bottom: 6px;
    }
    .desc-text2 {
      font-weight: bold;
      margin-bottom: 4px;
    }
    .award-num {
      color: #FFB504;
    }
  }

  .rank-head {
    background: #FFFFFF;
    border-radius: 19px 19px 0 0;
    .head-date {
      height: 35px;
      font-size: 12px;
      font-weight: 400;
      color: #838383;
      line-height: 35px;
      text-align: center;
    }
    .rank-head-title {
      display: flex;
      height: 28px;
      align-items: center;
      padding: 0 22px;
      background-color: #FFE7D5;
      color: #616161;
      .head-seq1 {
        flex: 4;
      }
      .head-seq2 {
        flex: 10;
        text-align: center;
      }
      .head-seq3 {
        flex: 10;
        text-align: right;
        padding-right: 10px;
      }
    }
  }
  .rank-wrap {
    flex: 1;
    background: #FFFFFF;
    color: #616161;
    padding-bottom: 160px;
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .rank-item {
    display: flex;
    padding: 0 16px;
    height: 28px;
    align-items: center;
    .rank-seq {
      flex: 4;
      padding-left: 8px;
    }
    .rank-user {
      flex: 10;
      display: flex;
      align-items: center;
      overflow: hidden;
      .user-avatar {
        width: 18px;
        height: 18px;
        border-radius: 9px;
        margin-right: 9px;
      }
      .rank-user-name {
        color: #616161;
        font-size: 15px;
        white-space: nowrap;
      }
    }
    .rank-profit {
      flex: 10;
      white-space: nowrap;
      text-align: right;
      padding-right: 10px;
    }
  }
  .rank-item-light {
    background-color: #FFE7D5;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/rank.js